export default __webpack_public_path__ + "re_project-800-9db2f5fa72cdd3c28767b712704704b3.png";